var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniversalMedicalRecordNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662542456661,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 52985,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M626.57 198.4H396.09c-0.6 0-1.1-0.49-1.1-1.1V99.77c0-0.6 0.49-1.1 1.1-1.1h230.49c0.6 0 1.1 0.49 1.1 1.1v97.53c-0.01 0.6-0.5 1.1-1.11 1.1z",
    "p-id": 52986,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M748.35 162.87h-90.58c-1.34 32.76-28.36 59.2-61.45 59.2h-170c-33.07 0-60.1-26.44-61.45-59.2h-90.56c-50.08 0-91.04 40.97-91.04 91.04v515.96c0 50.07 40.96 91.04 91.04 91.04h474.04c50.08 0 91.04-40.97 91.04-91.04V253.91c0-50.08-40.96-91.04-91.04-91.04zM682.1 672.79H340.56c-12.58 0-22.76-10.18-22.76-22.76s10.18-22.76 22.76-22.76H682.1c12.58 0 22.76 10.18 22.76 22.76s-10.18 22.76-22.76 22.76z m0-138.75H340.56c-12.58 0-22.76-10.18-22.76-22.76s10.18-22.76 22.76-22.76H682.1c12.58 0 22.76 10.18 22.76 22.76s-10.18 22.76-22.76 22.76z m0-138.74H340.56c-12.58 0-22.76-10.18-22.76-22.76 0-12.58 10.18-22.76 22.76-22.76H682.1c12.58 0 22.76 10.18 22.76 22.76 0 12.58-10.18 22.76-22.76 22.76z",
    "p-id": 52987,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalMedicalRecordNum);
export default __webpack_public_path__ + "static/media/universalMedicalRecordNum.d1e2f754.svg";
export { ForwardRef as ReactComponent };